import  { createContext, useState, ReactNode, FC } from "react";
import { VitalsDto } from "../vitals/types";
// Define the context type
export interface VitalsContextType {
  list: VitalsDto[];
  edit: VitalsDto | null;
  setEdit: (edit: VitalsDto | null) => void;
  setList: (list: VitalsDto[]) => void;
  success: boolean;
  setsuccess: (success: boolean) => void;
  show: boolean;
  setShow: (show: boolean) => void;
}
// Create the context
export const VitalsContext = createContext<VitalsContextType | undefined>(
  undefined
);

// Props for the provider
interface VitalsProviderProps {
  children: ReactNode;
}

// VitalsProvider Component
export const VitalsProvider: FC<VitalsProviderProps> = ({ children }) => {
  const [list, setList] = useState<VitalsDto[]>([]);
  const [edit, setEdit] = useState<VitalsDto | null>(null);
  const [success, setsuccess] = useState(false);
  const [show, setShow] = useState(false);

  return (
    <VitalsContext.Provider
      value={{
        list,
        setList,
        edit,
        setEdit,
        success,
        setsuccess,
        show,
        setShow
      }}
    >
      {children}
    </VitalsContext.Provider>
  );
};
